import {i18n} from '@yourcoach/i18n';

import type {AsyncStrategy} from '../utils';
import type {Invite} from './types';

import SuccessIcon from '../../../assets/icons/primary/Tick Square.svg';
import {alert} from '../../../components/alert';
import {isIamCoach} from '../../../utils/entity/isIamCoach';
import {AppError} from '../../../utils/errors/app';
import {logger} from '../../../utils/logger';
import {ResendInviteStrategyFactory} from './inviteResend/ResendInviteStrategyFactory';

type Config = {
  invite: Invite;
};

export {inviteResend};

const strategy: AsyncStrategy<Config> = async (roles, config) => {
  if (isIamCoach()) {
    return roles.coach(config);
  } else {
    return roles.client(config);
  }
};

async function inviteResend(config: Config) {
  return strategy({client: asClient, coach: asCoach}, config);
}

inviteResend.asCoach = asCoach;
inviteResend.asClient = asClient;

async function asClient(_config: Config) {
  throw new AppError('not_allowed');
}

async function asCoach({invite}: Config) {
  try {
    await ResendInviteStrategyFactory.createStrategy(invite).resendInvite();

    alert.show({
      buttons: [
        {
          label: i18n.t('shared:great_excl'),
          scheme: 'primary',
        },
      ],
      icon: SuccessIcon,
      iconColor: 'icon4',
      title: i18n.t('shared:invitation_success', {
        count: 1,
      }),
    });
  } catch (error) {
    logger.error(error);

    throw error;
  }
}
